function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "#231F20",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10 5.1h-.2c-.8 0-1.5-.7-1.5-1.5v-.5c0-.2-.2-.4-.4-.4h-.2c-.2 0-.4.2-.4.4v.5c0 .8-.7 1.5-1.5 1.5h-.3c-.3 0-.5.2-.5.4 0 .3.2.5.4.5h.2c.8 0 1.5.7 1.5 1.5V8c0 .2.2.4.4.4h.2c.2 0 .4-.2.4-.4v-.4c0-.8.7-1.5 1.5-1.5h.4c.2 0 .4-.2.4-.4 0-.4-.2-.6-.4-.6zM14.5 2h-.1c-.5 0-1-.4-1-1V.8c0-.1-.1-.3-.3-.3-.1 0-.3.1-.3.3v.3c0 .5-.4 1-1 1h-.1c-.1 0-.3.1-.3.3 0 .2.1.3.3.3h.1c.5 0 1 .4 1 1V4c0 .1.1.3.3.3.1 0 .3-.1.3-.3v-.4c0-.5.4-1 1-1h.1c.1 0 .3-.1.3-.3 0-.2-.1-.3-.3-.3zM17.9 6c-.6-.6-1.3-.8-2-.8s-1.5.3-2 .8l-3.7 3.699-9 8.997c-1.1 1.1-1.1 3 0 4.1 1.1 1.099 3 1.099 4.1 0l9-8.998 3.7-3.7C19 9 19 7.2 17.9 6zm-1.3 2.799l-2.4 2.4-1.5-1.5 2.4-2.4c.2-.2.5-.3.8-.3.3 0 .6.1.8.3.2.2.3.5.3.8-.1.3-.2.5-.4.7zM23.2 13.9h-.3c-1 0-1.7-.8-1.7-1.7v-.5c0-.3-.2-.5-.5-.5h-.1-.1c-.3 0-.5.2-.5.5v.5c0 1-.8 1.7-1.7 1.7H18c-.3 0-.5.2-.5.5s.2.5.5.5h.3c1 0 1.7.8 1.7 1.7v.6c0 .3.2.5.5.5h.2c.3 0 .5-.2.5-.5v-.5c0-1 .8-1.7 1.7-1.7h.3c.3 0 .5-.2.5-.5s-.2-.6-.5-.6z"
}));

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgComponent;